// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__DtzCt","productName":"Table_productName__3FeH_"};